// extracted by mini-css-extract-plugin
module.exports = {"root":"Subscribe_root__2_DvQ","title":"Subscribe_title__1A9Su","badge":"Subscribe_badge__yU6ji","text":"Subscribe_text__3eRbA"};